var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.university
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page university-page",
            attrs: { id: "print_university" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "25px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.university.hospitalName
                                    ? _vm.model.university.hospitalName
                                    : ""
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.university.reportName
                                    ? _vm.model.university.reportName
                                    : "大学生健康检查表"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "65%",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _vm._v("学校："),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.schoolName
                                ? _vm.model.university.schoolName
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _vm._v("检查日期："),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.checkDate
                                ? _vm.model.university.checkDate
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "65%",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _vm._v("班级："),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.className
                                ? _vm.model.university.className
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "none",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _vm._v("序  列 号："),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.serialNumber
                                ? _vm.model.university.serialNumber
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.name
                                ? _vm.model.university.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.sex
                                ? _vm.model.university.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("民族")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.nation
                                ? _vm.model.university.nation
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("出生日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.birthday
                                ? _vm.model.university.birthday
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("学历层次")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.education
                                ? _vm.model.university.education
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("联系电话")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.phone
                                ? _vm.model.university.phone
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身份证号")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.idcard
                                ? _vm.model.university.idcard
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("既往病史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.pastMedicalHistory
                                ? _vm.model.university.pastMedicalHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("过敏史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.allergyHistory
                                ? _vm.model.university.allergyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("家族史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.familyHistory
                                ? _vm.model.university.familyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("一般情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.height
                                ? _vm.model.university.height
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("cm")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.weight
                                ? _vm.model.university.weight
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("kg")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("BMI")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.bmi
                                ? _vm.model.university.bmi
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脉搏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.pulse
                                ? _vm.model.university.pulse
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("次/分")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血压")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.systolicPressure
                                ? _vm.model.university.systolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _vm._v("/"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.diastolicPressure
                                ? _vm.model.university.diastolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("mmHg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("裸眼视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.nakedLeftEyeVision
                                ? _vm.model.university.nakedLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("矫正视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.correctLeftEyeVision
                                ? _vm.model.university.correctLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.nakedRightEyeVision
                                ? _vm.model.university.nakedRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.correctRightEyeVision
                                ? _vm.model.university.correctRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("五官科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("眼底")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.fundus
                                ? _vm.model.university.fundus
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("听力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.hearing
                                ? _vm.model.university.hearing
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("咽喉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.pharynx
                                ? _vm.model.university.pharynx
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("口腔")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.oralCavity
                                ? _vm.model.university.oralCavity
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("辨色力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.distinguishColour
                                ? _vm.model.university.distinguishColour
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.facialFeaturesOther
                                ? _vm.model.university.facialFeaturesOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "5" },
                      },
                      [_vm._v("内科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("营养发育")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.development
                                ? _vm.model.university.development
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("神经精神")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.neuropsychology
                                ? _vm.model.university.neuropsychology
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("呼吸系统")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.systemBreathing
                                ? _vm.model.university.systemBreathing
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("循环系统")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.systemLoop
                                ? _vm.model.university.systemLoop
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝胆")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.liverAndGallbladder
                                ? _vm.model.university.liverAndGallbladder
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脾脏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.spleen
                                ? _vm.model.university.spleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肾脏")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.kidney
                                ? _vm.model.university.kidney
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.insideOther
                                ? _vm.model.university.insideOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("外科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.skin
                                ? _vm.model.university.skin
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("淋巴")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.lymph
                                ? _vm.model.university.lymph
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("甲状腺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.thyroid
                                ? _vm.model.university.thyroid
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脊椎")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.spine
                                ? _vm.model.university.spine
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("四肢")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.limb
                                ? _vm.model.university.limb
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("关节")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.joint
                                ? _vm.model.university.joint
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.surgeryOther
                                ? _vm.model.university.surgeryOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("X线检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.xray
                                ? _vm.model.university.xray
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("化验检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.laboratoryExamination
                                ? _vm.model.university.laboratoryExamination
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "30px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          height: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("检查结论")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "word-wrap": "break-word",
                          overflow: "auto",
                          "flex-wrap": "wrap",
                          "justify-content": "flex-start",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.university.inspectionResults
                                ? _vm.model.university.inspectionResults
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          height: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("医师签名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _vm.model.university.doctorSignature
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.university.doctorSignature,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }